<template>
    <div id="app">
        <div id="header">
            <CargadorDepartamentos @departamentos-cargados="departamentosCargados" :featureClicked="featureClicked" />
        </div>
        <div id="content">
            <Mapa :departamentos="departamentos" @featureClicked="setFeatureClicked" :pintarPor="pintarPor" />
            <ControlesMapa @pintarDeptos="pintarDeptos" @pintarProp="pintarProp"></ControlesMapa>
        </div>
        <div id="footer"></div>
    </div>
</template>

<script>
    import Mapa from '@/components/Mapa';
    import ControlesMapa from "@/components/ControlesMapa";
    import CargadorDepartamentos from "../CargadorDepartamentos";

    export default {
        name: 'App',
        components: {
            CargadorDepartamentos,
            Mapa,
            ControlesMapa
        },
        data: function() {
            return {
                departamentos: [],
                featureClicked: {},
                pintarPor: ''
            }
        },
        methods: {
            departamentosCargados(deptos) {
                // console.log("---departamentos-cargados---");
                // console.log(deptos);
                this.departamentos = deptos;
            },
            setFeatureClicked(feature) {
                console.log(feature);
                this.featureClicked=feature;
            },
            pintarDeptos(tipo) {
                this.pintarPor=tipo
            },
            pintarProp(tipo) {
                this.pintarPor=tipo
            }
        }
    }
</script>

<style>
    #app {
        font-family: Avenir, Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
        /*margin-top: 60px;*/
    }
    #content div {
        float: left;
    }
</style>
